export default "__VITE_ASSET__Cn_QSRm0__"